import { StatColumn } from "@bridgesplit/ui";

import { useWhirlpoolContext } from "../WhirlpoolContext";
import { useDepositLtv } from "./util";
import { useHealthChangeStats, useTokenAmountStats } from "../../clmm";

export default function WithdrawCtaStats() {
    const { depositForm, whirlpoolPosition } = useWhirlpoolContext();
    const depositLtv = useDepositLtv();
    const healthChangeStats = useHealthChangeStats(depositLtv);

    const tokenAmountStats = useTokenAmountStats({
        tokenAChange: depositForm.tokenAAmount ?? 0,
        tokenBChange: depositForm.tokenBAmount ?? 0,
        tokenA: whirlpoolPosition.tokenA,
        tokenB: whirlpoolPosition.tokenB
    });
    if (!depositForm.tokenAAmount || !depositForm.tokenBAmount) return null;

    return <StatColumn loading={depositLtv.isLoading} stats={[...tokenAmountStats, ...healthChangeStats]} />;
}
